import { Dispatch, SetStateAction } from 'react';

export enum DemoStatus {
  development="development",
  staging="staging",
  production="production",
  comingSoon="comingsoon",
}
export interface DemoDetails {
  tags?: Array<string>;
  mainDescriptor?: string;
  features?: Array<string>;
  useCases?: Array<string>;
  repositoryUrl?: string;
  repositoryName: string;
  repositoryNotes?: string;
  imageUrl?: string;
  videoUrl?: string;
  builderSpaceUrl?: string;
  embed?: boolean;
  sfdcTagCategory?: string; // Solution, Use Case, Guidance
  sfdcTagName?: string;
}


export interface LoadBalancedOriginDefinition {
  loadBalancerArn: string;
  dnsName: string;
  vpcId: string;
  visible?: boolean;
  type: "load-balanced";
  status?: DemoStatus;
}

export interface S3OriginDefinition {
  bucketName: string;
  visible?: boolean;
  type: "s3";
  status?: DemoStatus;
}



export interface Asset {
  path: string;  // Always starts with /assets/
  note: string;
  fileType: string;
  uploadedAt: string;
  lastModified: string;
  size?: number;
  url?: string;
}


export interface Infrastructure {
  type: 's3' | 'load-balanced' | '';
  bucketName?: string;
  loadBalancerArn?: string;
  dnsName?: string;
  vpcId?: string;
}

export interface DemoDefinition {
  name: string;
  description: string;
  demoDetails?: DemoDetails;
  path: string;
  visible?: boolean;
  status: DemoStatus;
  rank?: number;
}

export interface AdminDemoDefiniton extends DemoDefinition {
  infrastructure?: Infrastructure;
  deployedToPortal?: boolean;
}

export interface UserSettings {
  rememberLanguage: boolean;
  defaultLanguage?: string;
  rememberTheme: boolean;
  defaultTheme?: 'light' | 'dark';
}

export interface UserData {
  userId: string;
  userGivenName?: string;
  userFamilyName?: string;
  setUserId: Dispatch<SetStateAction<string>>;
  setUserGivenName: Dispatch<SetStateAction<string>>;
  setUserFamilyName: Dispatch<SetStateAction<string>>;
}

export interface FAQ {
  id: string;
  section: string;
  question: string;
  answer: string;
  createdAt: string;
  updatedAt: string;
}

export interface NavigationPanelState {
  collapsed?: boolean;
  collapsedSections?: Record<number, boolean>;
}
